import { Drawer, DrawerProps } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import { useDialogState } from '~ui-kit/hooks/use-dialog-state';
import { NavbarButton } from './navbar-button';

interface NavbarDrawerProps {
  children: (closeDrawer: () => void) => React.ReactNode;
  anchor?: DrawerProps['anchor'];
}

export function NavbarDrawer({ anchor = 'right', children }: NavbarDrawerProps) {
  const drawer = useDialogState();

  return (
    <>
      <NavbarButton onClick={drawer.open} icon={<MenuIcon />} aria-label="Menu" />

      <Drawer open={drawer.isOpen} anchor={anchor} onClose={drawer.close}>
        {children(close)}
      </Drawer>
    </>
  );
}
